import React from 'react';
import { LinearProgress } from '@mui/material';

export const ProgressBar = ({ bottom }: { bottom?: boolean }) => {
  return (
    <LinearProgress
      sx={{
        ...(bottom && {
          position: 'absolute',
          bottom: '0px',
          width: '100%',
        }),
      }}
    />
  );
};
